import React from "react";
import software from "../assets/img/software 101.jpeg";
import ifrs from "../assets/img/ifrs.jpg";
import deployment from "../assets/img/deployment.jpg";

const ServicesSection = () => {
  const services = [
    {
      title: "Software Solutions",
      image: software,
      description: "Explore our wide range of innovative software solutions:",
      items: [
        "ERP Systems",
        "Mobile & Web Applications",
        "CRM Solutions",
        "RFID Solutions",
        "Property Management Software",
      ],
    },
    {
      title: "IFRS Consultation",
      image: ifrs,
      description: "Comprehensive business solutions & professional services:",
      items: [
        "IFRS & Financial Services",
        "Business Development",
        "Tax & Audit Services",
        "Training & Support",
        "Strategic Planning",
      ],
    },
    {
      title: "System Deployment",
      image: deployment,
      description: "Comprehensive system deployment services:",
      items: [
        "QMS Implementation",
        "FSMS Integration",
        "Gap Analysis",
        "Quality Assurance",
        "Ongoing Support",
      ],
    },
  ];

  return (
    <div className="container-fluid service overflow-hidden py-5">
      <div className="container py-5">
        <div
          className="section-title text-center mb-5"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="sub-style">
            <h5 className="sub-title" style={{ color: "#FFAA00" }}>
              Our Core Services
            </h5>
          </div>
          <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>
            Comprehensive Business Solutions
          </h1>
          <p className="mb-0">
            Delivering innovative technology solutions and professional services
            to transform your business
          </p>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div
              className="col-lg-4"
              data-aos="fade-up"
              data-aos-delay={100 + index * 200}
              key={index}
            >
              <div className="service-item rounded h-100 shadow-sm bg-white">
                <div className="service-img rounded overflow-hidden">
                  <img
                    className="img-fluid w-100"
                    src={service.image}
                    alt={service.title}
                  />
                </div>
                <div className="service-content rounded p-4">
                  <h5 className="mb-4" style={{ color: "#A71717" }}>
                    {service.title}
                  </h5>
                  <p className="mb-4 text-muted">{service.description}</p>
                  <ul className="list-unstyled mb-4">
                    {service.items.map((item, i) => (
                      <li key={i}>
                        <i className="fa fa-check text-primary me-2"></i>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <a className="btn btn-light rounded-pill py-2 px-4 mt-2" href="">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
